import { TpDbActionStepDefinition } from '../interfaces';
import dbActionStepTypeAddPropertyGroupAsColumn from './dbActionStepTypeAddPropertyGroupAsColumn';
import dbActionStepTypeAddSectionElement from './dbActionStepTypeAddSectionElement';
import dbActionStepTypeAddWidget from './dbActionStepTypeAddWidget';
import dbActionStepTypeCalculateColumn from './dbActionStepTypeCalculateColumn';
import dbActionStepTypeCalculateVariable from './dbActionStepTypeCalculateVariable';
import dbActionStepTypeCondition from './dbActionStepTypeCondition';
import dbActionStepTypeError from './dbActionStepTypeError';
import dbActionStepTypeGetRowValue from './dbActionStepTypeGetRowValue';
import dbActionStepTypeTableJoin from './dbActionStepTypeTableJoin';
import dbActionStepTypeTransferSelection from './dbActionStepTypeTransferSelection';
import dbActionStepTypeUserPrompt from './dbActionStepTypeUserPrompt';
import dbActionStepTypeAddAsyncColumn from './dbActionStepTypeAddAsyncTableColumn';
import dbActionStepSetChartFilter from './dbActionStepTypeSetChartFilter';
import dbActionStepSetChartAspect from './dbActionStepTypeSetChartAspect';
import dbActionStepSetChartCompoundAspect from './dbActionStepTypeSetChartCompoundAspect';
import dbActionStepSetChartTitle from './dbActionStepTypeSetChartTitle';
import dbActionStepSetChartConfigParam from './dbActionStepTypeSetChartConfigParam';

export const stepDefinitionsList = [
  dbActionStepTypeUserPrompt,
  dbActionStepTypeCalculateVariable,
  dbActionStepTypeCalculateColumn,
  dbActionStepTypeAddWidget,
  dbActionStepSetChartAspect,
  dbActionStepSetChartCompoundAspect,
  dbActionStepSetChartFilter,
  dbActionStepSetChartTitle,
  dbActionStepSetChartConfigParam,
  dbActionStepTypeAddSectionElement,
  dbActionStepTypeTableJoin,
  dbActionStepTypeTransferSelection,
  dbActionStepTypeGetRowValue,
  dbActionStepTypeCondition,
  dbActionStepTypeError,
  dbActionStepTypeAddPropertyGroupAsColumn,
  dbActionStepTypeAddAsyncColumn,
];

export const stepDefinitionMap: { [id: string]: TpDbActionStepDefinition } = {};

for (const stepDef of stepDefinitionsList) stepDefinitionMap[stepDef.stepType] = stepDef;
